import { HlmSeparator } from './lib/hlm-separator'

export * from './lib/hlm-separator'

export const HlmSeparatorImports = [HlmSeparator] as const
